/**
 * Admin → Sessions.
 *
 * Currently active MCP sessions. Polls every 30s. "Force disconnect" is a
 * stub for now — there's no API yet, so it shows a "coming soon" toast.
 */
import { adminApi } from "../../api/admin";
import { PageHeader } from "../../components/PageHeader";
import { Pill } from "../../components/Pill";
import { QueryBoundary } from "../../components/QueryBoundary";
import { useToast } from "../../components/toast/context";
import { formatRelative } from "../../lib/formatRelative";

export function SessionsPage() {
  const query = adminApi.sessions.list();
  const toast = useToast();

  return (
    <>
      <PageHeader
        title="Sessions"
        description="Active MCP sessions. Refreshes every 30s."
      />

      <QueryBoundary
        query={query}
        empty={
          <div className="empty-state">
            <div className="title">No active sessions</div>
            <p className="hint">
              Sessions appear here once a user opens a TUI / claude-code
              connection.
            </p>
          </div>
        }
        isEmpty={(s) => s.length === 0}
      >
        {(rows) => (
          <div className="panel panel--flush overflow-x-auto">
            <table className="table">
              <thead>
                <tr>
                  <th>Session ID</th>
                  <th>User</th>
                  <th>Workspace</th>
                  <th>Activated</th>
                  <th>Started</th>
                  <th>Last seen</th>
                  <th className="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <span className="font-mono text-xs text-ink-low">
                        {row.id.slice(0, 12)}…
                      </span>
                    </td>
                    <td className="text-sm text-ink-medium">
                      {row.user_email || "—"}
                    </td>
                    <td>
                      {row.workspace ? (
                        <span className="tag-chip">{row.workspace}</span>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>
                      {row.activated ? (
                        <Pill value="active" />
                      ) : (
                        <Pill value="pending" />
                      )}
                    </td>
                    <td className="text-sm text-ink-low tnum">
                      {formatRelative(row.created_at)}
                    </td>
                    <td className="text-sm text-ink-low tnum">
                      {formatRelative(row.last_seen_at)}
                    </td>
                    <td className="text-right">
                      <button
                        type="button"
                        className="btn btn-ghost btn-sm"
                        onClick={() => toast.error("Force disconnect — coming soon")}
                      >
                        Force disconnect
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </QueryBoundary>
    </>
  );
}
